(() => {
  'use strict';

  const init = () => {
    const section = document.querySelector('[data-bb-immersive]');
    const firstFrame = section?.querySelector('[data-bb-tree-frame]');
    if (!section || !firstFrame) return;

    const frames = [
      'https://cdn.shopify.com/s/files/1/1081/0913/6217/files/bough-bow-immersive-tree.png?v=1792003414',
      'https://cdn.shopify.com/s/files/1/1081/0913/6217/files/bough-bow-tree-angle-45.png?v=1792003689',
      'https://cdn.shopify.com/s/files/1/1081/0913/6217/files/bough-bow-tree-angle-90.png?v=1792003527',
      'https://cdn.shopify.com/s/files/1/1081/0913/6217/files/bough-bow-tree-angle-135.png?v=1792003701',
      'https://cdn.shopify.com/s/files/1/1081/0913/6217/files/bough-bow-tree-angle-180.png?v=1792003537',
      'https://cdn.shopify.com/s/files/1/1081/0913/6217/files/bough-bow-tree-angle-135.png?v=1792003701',
      'https://cdn.shopify.com/s/files/1/1081/0913/6217/files/bough-bow-tree-angle-90.png?v=1792003527',
      'https://cdn.shopify.com/s/files/1/1081/0913/6217/files/bough-bow-tree-angle-45.png?v=1792003689',
      'https://cdn.shopify.com/s/files/1/1081/0913/6217/files/bough-bow-immersive-tree.png?v=1792003414'
    ];

    const preloaded = frames.map((src) => {
      const image = new Image();
      image.src = src;
      return image;
    });

    let current = 0;
    let frameImage = firstFrame;
    let animationFrame = 0;
    let lastProgress = -1;
    firstFrame.classList.add('is-visible');

    const pageSection = section.closest('.shopify-section');
    const productSection = pageSection?.nextElementSibling;
    if (productSection) {
      productSection.id = 'bb-product-collection';
      productSection.style.scrollMarginTop = '24px';
    }

    const scrollRoot = window.innerWidth >= 990
      ? (document.querySelector('.page-wrapper') || window)
      : window;

    const showFrame = (index) => {
      if (index === current || !preloaded[index]?.complete) return;
      const nextFrame = document.createElement('img');
      nextFrame.className = 'bb-immersive__frame';
      nextFrame.alt = '';
      nextFrame.setAttribute('aria-hidden', 'true');
      nextFrame.width = 1024;
      nextFrame.height = 1536;
      nextFrame.src = frames[index];
      section.querySelector('.bb-immersive__tree').append(nextFrame);
      requestAnimationFrame(() => nextFrame.classList.add('is-visible'));
      frameImage.classList.remove('is-visible');
      const previous = frameImage;
      frameImage = nextFrame;
      current = index;
      setTimeout(() => previous.remove(), 150);
    };

    const update = () => {
      animationFrame = 0;
      const visibleHeight = scrollRoot === window ? window.innerHeight : scrollRoot.clientHeight;
      const range = Math.max(1, section.offsetHeight - visibleHeight);
      const progress = Math.max(0, Math.min(1, -section.getBoundingClientRect().top / range));
      if (Math.abs(progress - lastProgress) < 0.002) return;
      lastProgress = progress;
      showFrame(Math.round(progress * (frames.length - 1)));
    };

    const requestUpdate = () => {
      if (!animationFrame) animationFrame = requestAnimationFrame(update);
    };

    scrollRoot.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    update();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

